import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {visitConfigurationsFeature} from "../state/visit-configuration-state/visit-configuration.state";
import {Observable, take} from "rxjs";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";
import {
  VisitConfigurationActions,
  VisitConfigurationAPiActions
} from "../state/visit-configuration-state/visit-configuration.action";
import {VisitConfigurationModel} from "../../models/visit-configuration.model";
import {accountsFeature} from "../../../account/angular/state/accounts.state";
import {servicesFeature} from "../../../deliveries/angular/state/services.state";
import {CallTemplatesQuery, VisitConfigurationHttpService} from "./visit-configuration-http.service";
import {VisitConfigurationTotals} from "../../components/visit-configurations-view/visit-configurations-view.component";
import {ProcessTrackingModel} from "../../../commons/models/process-tracking.model";

@Injectable()
export class VisitConfigurationFacadeService implements EntitiesFacade<VisitConfigurationModel> {

  constructor(
    @Inject(Store) private store: Store<VisitConfigurationModel>,
    @Inject(VisitConfigurationHttpService) private visitConfigurationHttpService: VisitConfigurationHttpService
  ) {}

  clearStore(): void {
    this.store.dispatch(VisitConfigurationActions.clearStore());
  }

  createOne(visitConfiguration: VisitConfigurationModel): void {
    this.store.dispatch(VisitConfigurationAPiActions.createOne({visitConfiguration: visitConfiguration}));
  }

  updateOne(visitConfiguration: VisitConfigurationModel): void {
    this.store.dispatch(VisitConfigurationAPiActions.updateOne({id: visitConfiguration.id, visitConfiguration: visitConfiguration}));
  }

  updateMany(visitConfigurations: VisitConfigurationModel[]): void {

  }

  deleteOne(id: string): void {
    this.store.dispatch(VisitConfigurationAPiActions.deleteOne({id: id}));
  }

  getMany(params?: Object): void {
    this.store.dispatch(VisitConfigurationAPiActions.getMany({params: params}));
  }

  fetchNext(params?: Object): void {
    this.store.select(visitConfigurationsFeature.selectIsLoading()).pipe(take(1)).subscribe((isLoading) => {
      if (isLoading) {
        return;
      }
      this.store.select(visitConfigurationsFeature.selectCursor()).pipe(take(1)).subscribe((cursor) => {
        if (!!cursor) {
          this.store.dispatch(VisitConfigurationAPiActions.getMany({params: params}));
        }
      });
    });
  }

  getInfiniteScrollEntities(params?: Object): void {
    this.store.dispatch(VisitConfigurationAPiActions.getInfiniteScroll({params: params}));
  }

  getOne(id: string): void {
    this.store.dispatch(VisitConfigurationAPiActions.getOne({id: id}));
  }

  removeAll(): void {
    this.store.dispatch(VisitConfigurationActions.removeAll());
  }

  removeByIds(ids: string[]): void {
    this.store.dispatch(VisitConfigurationActions.removeMany({ids: ids}));
  }

  selectOne(id: string) {
    return this.store.select(visitConfigurationsFeature.selectOne(id));
  }

  selectByIds(ids: string[]): Observable<VisitConfigurationModel[]> {
    return this.store.select(visitConfigurationsFeature.selectByIds(ids));
  }

  selectAll(): Observable<VisitConfigurationModel[]> {
    return this.store.select(visitConfigurationsFeature.selectMany());
  }

  selectInfiniteScrollEntities(): Observable<VisitConfigurationModel[]> {
    return undefined;
  }

  setMany(visitConfigurations: VisitConfigurationModel[], isAppendFirst?: boolean): void {
    this.store.dispatch(VisitConfigurationActions.setMany({visitConfigurations: visitConfigurations, isAppendFirst: isAppendFirst}))
  }

  setOne(visitConfiguration: VisitConfigurationModel, isAppendFirst?: boolean): void {
    this.store.dispatch(VisitConfigurationActions.setOne({visitConfiguration: visitConfiguration, isAppendFirst: isAppendFirst}))

  }

  subscribeToChannels(): void {
    throw new Error('Method not implemented.');
  }

  unsubscribeFromChannels(): void {
    throw new Error('Method not implemented.');
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.select(visitConfigurationsFeature.selectIsLoading());
  }

  getVisitConfigurationTotals(params?: any): Observable<VisitConfigurationTotals> {
    return this.visitConfigurationHttpService.getTotals(params);
  }

  expireVisitConfigurations(payload: CallTemplatesQuery, params?: any): Observable<ProcessTrackingModel> {
    return this.visitConfigurationHttpService.expireMany(payload, params);
  }

}
